import { useAuthenticatedAxiosInstance } from './useAuthenticatedAxiosInstance';
import { useCallback } from 'react';
import { getEnvironmentConfig } from '../environmentConfig';

export const useFeatureFlagApi = () => {
    const api = useAuthenticatedAxiosInstance(`${getEnvironmentConfig().graphServiceUrl}`);

    const getFeatureFlags = useCallback(async (): Promise<Record<string, boolean>> => {
        const result = await api.get('/feature-flags');
        return result.data.flags;
    }, [api]);

    return { getFeatureFlags };
};
